import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import AllConsultants from '../../../components/AllConsultants';
import MultiColumnCTAWithDivider from '../../../components/MultiColumnCTAWithDivider';

export default function MeetTheTeam({
    global,
    all_consultants,
    all_talent_acquisition_team
}) {
    return (
        <>
            <SeoHead
                page_name={`Meet the team | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`about-us/meet-the-team`}
            />
            <MainBanner
                global={global}
                pathPrefix={`meet_the_team_page.main_banner`}
                customClass={``}
                editableContent={
                `meet_the_team_page.main_banner.content`
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                secondary_breadcrumb_title={'About Us'}
                secondary_breadcrumb_url={'/about-us'}
                breadcrumb_title={`Meet the Team`}
            />
            <AllConsultants
                global={global}
                pathPrefix={`meet_the_team_page.all_consultants`}
                customClass={`py-5 grayGradientBg`}
                content={<>
                    <h2>Our Team</h2>
                </>}
                content_2={
                    <>
                        <h2>Talent Acquisition Team</h2>
                    </>
                }
                post={all_consultants}
                post2={all_talent_acquisition_team}
            />
            <MultiColumnCTAWithDivider
                global={global}
                pathPrefix={`meet_the_team_page.multi_column_cta`}
                customClass={`pt-5 pb-md-4 pb-5`}
                left_content={
                    <>
                        <h2>Get in Touch</h2>
                    </>
                }
                right_content={
                    <>
                        <h2>Work for us</h2>
                    </>
                }
                buttonLink2={`/`}
                buttonLink1={`/`}
                buttonTitle1={`Contact us`}
                buttonTitle2={`Join us now`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const consultants = (await Collection('consultants'));
    const talent_acquisition_team = (await Collection('consultants'))
        .filter(function (post) {
            return (
                post.tag?.en.includes(`Talent Acquisition Team`)
            );
        });
    const all_talent_acquisition_team = talent_acquisition_team.orderBy('_order').getItems();
    const all_consultants = consultants.orderBy('_order').getItems();

    return {
        props: {
            global,
            all_consultants,
            all_talent_acquisition_team
        }
    };
}
